import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from 'swiper/modules'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'

function Testimonials() {
  return (
    <section id="testimonials" className="testimonials section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>Discover the experiences of those who have worked with us and trusted our services</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay={100}>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000 }}
          loop={true}
          className="mySwiper"
        >
          {/* Testimonial 1 */}
          <SwiperSlide>
            <div className="testimonial-item">
              <div className="row gy-4 justify-content-center">
                <div className="col-lg-6">
                  <div className="testimonial-content">
                    <p>
                      <i className="bi bi-quote quote-icon-left" />
                      <span>Their attention to detail and commitment to quality stood out.A brand i trust and will gladly work with again.</span>
                      <i className="bi bi-quote quote-icon-right" />
                    </p>
                    <h3>Thalal</h3>
                    {/* <h4>Project Manager</h4> */}
                    <div className="stars">
                      <i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 text-center">
                  <img src="/assets/img/testimonials/testimonial-1.webp" className="img-fluid testimonial-img" alt="Amina" />
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Testimonial 2 */}
          <SwiperSlide>
            <div className="testimonial-item">
              <div className="row gy-4 justify-content-center">
                <div className="col-lg-6">
                  <div className="testimonial-content">
                    <p>
                      <i className="bi bi-quote quote-icon-left" />
                      <span>Reliable, innovative and incredibly efficient. They delivered results that matched their strong reputation</span>
                      <i className="bi bi-quote quote-icon-right" />
                    </p>
                    <h3>Safwan</h3>
                    {/* <h4>Designer</h4> */}
                    <div className="stars">
                      <i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 text-center">
                  <img src="/assets/img/testimonials/testimonial-2.webp" className="img-fluid testimonial-img" alt="Sara Wilsson" />
                </div>
              </div>
            </div>
          </SwiperSlide>

        </Swiper>
      </div>
    </section>
  )
}

export default Testimonials
